/**
 * GULP Skin — Logo Water Bounce
 * When the header scroll state changes, the logo does a soft springy
 * squish-and-bounce — like water being gently pushed.
 * Pure CSS transform, no distortion.
 */
(function () {
  'use strict';

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var logo = null;

  function getLogoEl() {
    if (!logo) logo = document.querySelector('.logo__image-link');
    return logo;
  }

  function triggerBounce() {
    var el = getLogoEl();
    if (!el) return;

    // Remove then re-add so re-triggering mid-animation restarts cleanly
    el.classList.remove('gulp-logo-bounce');
    // Force reflow so the browser registers the removal
    void el.offsetWidth;
    el.classList.add('gulp-logo-bounce');
  }

  function initLogoBounce() {
    var wasScrolled = document.body.classList.contains('has-scrolled');

    var el = getLogoEl();
    if (el) {
      el.addEventListener('animationend', function () {
        el.classList.remove('gulp-logo-bounce');
      });
    }

    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].attributeName === 'class') {
          var isScrolled = document.body.classList.contains('has-scrolled');
          if (isScrolled !== wasScrolled) {
            wasScrolled = isScrolled;
            triggerBounce();
          }
        }
      }
    });

    observer.observe(document.body, { attributes: true });
  }

  function initAtcBounce() {
    // Delegate from document so it works on dynamically rendered forms
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-add-to-cart]');
      if (!btn) return;
      btn.classList.remove('gulp-btn-bounce');
      void btn.offsetWidth; // reflow to restart
      btn.classList.add('gulp-btn-bounce');
    });

    document.addEventListener('animationend', function (e) {
      if (e.target.classList.contains('gulp-btn-bounce')) {
        e.target.classList.remove('gulp-btn-bounce');
      }
    });
  }

  function init() {
    initLogoBounce();
    initAtcBounce();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
